module.exports = __webpack_public_path__ + "static/media/Calendar.9f1eda17.css";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-calendar/dist/Calendar.css
// module id = 2012
// module chunks = 0